exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.collapsed[data-v-71aecd71] {\r\n    -webkit-transition: opacity 1s;\r\n    transition: opacity 1s;\n}\n.caret-report[data-v-71aecd71] {\r\n    position: absolute;\r\n    top: 8px;\r\n    right: 15px;\r\n    display: inline-block;\r\n    width: 0;\r\n    height: 0;\r\n    margin-left: 2px;\r\n    vertical-align: middle;\r\n    border-top: 4px dashed;\r\n    border-top: 4px solid;\r\n    border-right: 4px solid transparent;\r\n    border-left: 4px solid transparent;\n}\n.sidebar-mini[data-v-71aecd71] {\r\n    min-width: 30px;\r\n    height: 5px;\n}\r\n", ""]);

// exports
